import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import iWillLogo from '../assets/iWillLogo.png';
import NetworkStatus from 'components/NetworkStatus';

export default function GetStartedLayout() {
  return (
    <main className="flex min-h-screen flex-col bg-white">
      <div className="fixed left-0 top-0 z-50 w-full items-center bg-white shadow-2xl">
        <NetworkStatus />
        <div className="mx-6 flex flex-col items-center p-2">
          <Link className="mr-5 1xl:mr-10" to="/">
            <img src={iWillLogo} alt="iWillLogo" className="h-10 w-32" />
          </Link>
        </div>
      </div>
      <div className="mx-auto mt-36 flex w-full grow flex-col">
        <Outlet />
      </div>
    </main>
  );
}
